import { FILES_URL } from "../Config";
import { Purpose } from "../domain/enums/Purpose";
import { IBaseModel } from "../domain/models/BaseModel";
import { IFile } from "../domain/models/File";

export class BaseModelImpl<T> implements IBaseModel<T> {
    files?: IFile[];
    private picturePath?: string;

    assignData(data?: T) {
        if (!data) {
            return;
        }
        Object.assign(this, data);
    }

    pictureExists(purposeType: Purpose = Purpose.COVER): boolean {
        if (!this.files) return false;
        this.picturePath = this.files.find(
            (file) => file.purposeType === purposeType
        )?.filePath;

        return !!this.picturePath;
    }

    getPictureUrl(): string | null {
        if (!this.picturePath) return null;
        return `${FILES_URL}/${this.picturePath}`;
    }
}
